import {action} from 'typesafe-actions';
import {ClaimantsActionTypes, IClaimant} from './claimants.types';

export const selectClaimantId = (claimantId: string) => action(ClaimantsActionTypes.SELECT_CLAIMANT, claimantId);
export const unselectClaimant = action(ClaimantsActionTypes.UNSELECT_CLAIMANT);
export const addClaimant = (claimant: IClaimant) => action(ClaimantsActionTypes.ADD_CLAIMANT, claimant);
export const updateClaimant = (claimant: IClaimant) => action(ClaimantsActionTypes.UPDATE_CLAIMANT, claimant);
